
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { DataTableHeader } from 'vuetify';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Wait } from '@/__env/ext';
    import { Chat } from '@/__env/lib/MercadoLibre/Chats';
    import menu_pedidos from './lista-listado-item-pedidos.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            menu_pedidos,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop() public Item: Chat;
        @Watch( 'Item', { immediate: true } )
        onItem()
        {
            this.Chat = this.Item;
        }

        public Chat: Chat = null;
        public Escribiendo: boolean = false;

        @Prop() public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }

        protected Intervalo: any = null;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
            clearInterval( this.Intervalo );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.onRecargarUltimoMensaje.subscribe( x =>
            {
                if ( x.chat == this.Chat.Id )
                    this.RecargarUltimoMensaje( x );
            } ) );
            this.Intervalo = setInterval( () => { this.Recargar(); }, 30000 );
        }


        async RecargarUltimoMensaje( x: any )
        {
            console.log( 'eaea', 3 );
            await this.Chat.RecargarUltimoMensaje( x );
            this.Recargar();
        }

        public Refresh: boolean = true;
        public Recargar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
